// extracted by mini-css-extract-plugin
export default {"container":"dur_2AwOn"};